module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 154,
	"w": 360,
	"h": 360,
	"nm": "Waving_hand",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "waving_hand Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": -22.308,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						182,
						188,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						132.5,
						142.5,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						128.167,
						128.167,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.554,
											"y": 1
										},
										"o": {
											"x": 0.426,
											"y": 0
										},
										"t": 0,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														4.002,
														26.328
													],
													[
														-9.235,
														1.247
													],
													[
														-2.928,
														-13.315
													],
													[
														2.565,
														-35.986
													]
												],
												"o": [
													[
														3.289,
														-35.633
													],
													[
														-1.401,
														-9.213
													],
													[
														10.056,
														-1.358
													],
													[
														5.755,
														26.165
													],
													[
														5.454,
														48.632
													]
												],
												"v": [
													[
														-16.821,
														61.14
													],
													[
														-27.853,
														-42.098
													],
													[
														-15.333,
														-60.643
													],
													[
														4.241,
														-39.872
													],
													[
														16.925,
														57.365
													]
												],
												"c": false
											}
										]
									},
									{
										"i": {
											"x": 0.565,
											"y": 1
										},
										"o": {
											"x": 0.457,
											"y": 0
										},
										"t": 80.561,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														-7.762,
														28.465
													],
													[
														-9.319,
														0.012
													],
													[
														3.564,
														-13.159
													],
													[
														2.565,
														-35.986
													]
												],
												"o": [
													[
														8.242,
														-66.178
													],
													[
														2.452,
														-8.991
													],
													[
														9.317,
														-0.011
													],
													[
														-8.28,
														30.573
													],
													[
														5.454,
														48.632
													]
												],
												"v": [
													[
														-16.821,
														61.14
													],
													[
														1.66,
														-44.236
													],
													[
														18.515,
														-61.129
													],
													[
														34.167,
														-39.945
													],
													[
														16.925,
														57.365
													]
												],
												"c": false
											}
										]
									},
									{
										"t": 154,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														4.002,
														26.328
													],
													[
														-9.235,
														1.247
													],
													[
														-2.928,
														-13.315
													],
													[
														2.565,
														-35.986
													]
												],
												"o": [
													[
														3.289,
														-35.633
													],
													[
														-1.401,
														-9.213
													],
													[
														10.056,
														-1.358
													],
													[
														5.755,
														26.165
													],
													[
														5.454,
														48.632
													]
												],
												"v": [
													[
														-16.821,
														61.14
													],
													[
														-27.853,
														-42.098
													],
													[
														-15.333,
														-60.643
													],
													[
														4.241,
														-39.872
													],
													[
														16.925,
														57.365
													]
												],
												"c": false
											}
										]
									}
								],
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 12,
								"ix": 5
							},
							"lc": 2,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									127.045,
									77.779
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.554,
											"y": 1
										},
										"o": {
											"x": 0.426,
											"y": 0
										},
										"t": 0,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														3.947,
														29.803
													],
													[
														-9.264,
														1.012
													],
													[
														-0.916,
														-8.544
													],
													[
														2.419,
														-42.238
													]
												],
												"o": [
													[
														-0.031,
														-29.456
													],
													[
														-1.224,
														-9.238
													],
													[
														8.969,
														-0.98
													],
													[
														0,
														0
													],
													[
														-2.427,
														42.375
													]
												],
												"v": [
													[
														-16.867,
														58.864
													],
													[
														-27.28,
														-37.106
													],
													[
														-12.695,
														-54.412
													],
													[
														6.89,
														-38.179
													],
													[
														16.97,
														58.669
													]
												],
												"c": false
											}
										]
									},
									{
										"i": {
											"x": 0.565,
											"y": 1
										},
										"o": {
											"x": 0.457,
											"y": 0
										},
										"t": 80.561,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														-9.674,
														30.273
													],
													[
														-9.205,
														-1.451
													],
													[
														2.593,
														-9.106
													],
													[
														2.328,
														-42.38
													]
												],
												"o": [
													[
														-0.031,
														-29.456
													],
													[
														2.837,
														-8.877
													],
													[
														8.556,
														1.348
													],
													[
														0,
														0
													],
													[
														-2.328,
														42.38
													]
												],
												"v": [
													[
														-16.867,
														58.864
													],
													[
														-0.037,
														-41.911
													],
													[
														20.12,
														-55.914
													],
													[
														32.895,
														-38.237
													],
													[
														16.971,
														58.669
													]
												],
												"c": false
											}
										]
									},
									{
										"t": 154,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														3.947,
														29.803
													],
													[
														-9.264,
														1.012
													],
													[
														-0.916,
														-8.544
													],
													[
														2.419,
														-42.238
													]
												],
												"o": [
													[
														-0.031,
														-29.456
													],
													[
														-1.224,
														-9.238
													],
													[
														8.969,
														-0.98
													],
													[
														0,
														0
													],
													[
														-2.427,
														42.375
													]
												],
												"v": [
													[
														-16.867,
														58.864
													],
													[
														-27.28,
														-37.106
													],
													[
														-12.695,
														-54.412
													],
													[
														6.89,
														-38.179
													],
													[
														16.971,
														58.669
													]
												],
												"c": false
											}
										]
									}
								],
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 12,
								"ix": 5
							},
							"lc": 2,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									93.091,
									80.251
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.554,
											"y": 1
										},
										"o": {
											"x": 0.426,
											"y": 0
										},
										"t": 0,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														7.899,
														28.694
													],
													[
														-9.052,
														2.215
													],
													[
														-4.155,
														-12.184
													],
													[
														2.44,
														-47.888
													],
													[
														0,
														0
													],
													[
														-12.821,
														-14.977
													],
													[
														9.334,
														-7.99
													],
													[
														7.885,
														-20.667
													],
													[
														48.626,
														2.758
													],
													[
														-0.393,
														33.813
													],
													[
														-0.22,
														34.259
													],
													[
														2.415,
														20.117
													],
													[
														-9.693,
														0.686
													],
													[
														-0.683,
														-8.734
													],
													[
														0.672,
														-34.138
													]
												],
												"o": [
													[
														1.194,
														-29.382
													],
													[
														-2.473,
														-8.985
													],
													[
														11.064,
														-2.707
													],
													[
														3.255,
														9.544
													],
													[
														-0.236,
														4.635
													],
													[
														13.577,
														-28.735
													],
													[
														12.822,
														14.978
													],
													[
														-9.333,
														7.99
													],
													[
														-7.885,
														20.668
													],
													[
														-48.626,
														-2.758
													],
													[
														0.078,
														-6.751
													],
													[
														0.22,
														-34.259
													],
													[
														-1.111,
														-9.253
													],
													[
														9.294,
														-0.657
													],
													[
														0,
														0
													],
													[
														-0.879,
														44.662
													]
												],
												"v": [
													[
														-1.694,
														-8.671
													],
													[
														-12.32,
														-97.705
													],
													[
														-1.244,
														-117.075
													],
													[
														21.425,
														-95.065
													],
													[
														32.146,
														-7.089
													],
													[
														30.948,
														0.244
													],
													[
														90.834,
														-33.267
													],
													[
														78.599,
														4.289
													],
													[
														46.71,
														49.642
													],
													[
														-29.201,
														113.874
													],
													[
														-103.263,
														47.13
													],
													[
														-103.088,
														14.782
													],
													[
														-110.236,
														-79.633
													],
													[
														-96.064,
														-98.178
													],
													[
														-77.212,
														-82.566
													],
													[
														-69.379,
														-4.701
													]
												],
												"c": false
											}
										]
									},
									{
										"i": {
											"x": 0.565,
											"y": 1
										},
										"o": {
											"x": 0.457,
											"y": 0
										},
										"t": 80.561,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														-7.599,
														27.759
													],
													[
														-9.263,
														-1.02
													],
													[
														2.957,
														-12.529
													],
													[
														2.44,
														-47.888
													],
													[
														0,
														0
													],
													[
														-12.821,
														-14.977
													],
													[
														9.334,
														-7.99
													],
													[
														7.885,
														-20.667
													],
													[
														48.626,
														2.758
													],
													[
														-0.393,
														33.813
													],
													[
														-0.22,
														34.259
													],
													[
														-4.808,
														20.189
													],
													[
														-9.319,
														0.011
													],
													[
														-0.012,
														-9.318
													],
													[
														0.672,
														-34.138
													]
												],
												"o": [
													[
														1.194,
														-29.382
													],
													[
														2.461,
														-8.988
													],
													[
														8.155,
														0.898
													],
													[
														-2.419,
														10.251
													],
													[
														-0.236,
														4.635
													],
													[
														13.577,
														-28.735
													],
													[
														12.822,
														14.978
													],
													[
														-9.333,
														7.99
													],
													[
														-7.885,
														20.668
													],
													[
														-48.626,
														-2.758
													],
													[
														0.078,
														-6.751
													],
													[
														0.22,
														-34.259
													],
													[
														2.159,
														-9.065
													],
													[
														9.317,
														-0.012
													],
													[
														0,
														0
													],
													[
														-0.879,
														44.662
													]
												],
												"v": [
													[
														-1.694,
														-8.671
													],
													[
														14.323,
														-99.865
													],
													[
														34.481,
														-116.758
													],
													[
														49.1,
														-95.161
													],
													[
														32.146,
														-7.089
													],
													[
														30.948,
														0.244
													],
													[
														90.834,
														-33.267
													],
													[
														78.599,
														4.289
													],
													[
														46.71,
														49.642
													],
													[
														-29.201,
														113.874
													],
													[
														-103.263,
														47.13
													],
													[
														-103.088,
														14.782
													],
													[
														-92.28,
														-82.595
													],
													[
														-75.425,
														-99.488
													],
													[
														-58.844,
														-82.638
													],
													[
														-69.379,
														-4.701
													]
												],
												"c": false
											}
										]
									},
									{
										"t": 154,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														7.899,
														28.694
													],
													[
														-9.052,
														2.215
													],
													[
														-4.155,
														-12.184
													],
													[
														2.44,
														-47.888
													],
													[
														0,
														0
													],
													[
														-12.821,
														-14.977
													],
													[
														9.334,
														-7.99
													],
													[
														7.885,
														-20.667
													],
													[
														48.626,
														2.758
													],
													[
														-0.393,
														33.813
													],
													[
														-0.22,
														34.259
													],
													[
														2.415,
														20.117
													],
													[
														-9.693,
														0.686
													],
													[
														-0.683,
														-8.734
													],
													[
														0.672,
														-34.138
													]
												],
												"o": [
													[
														1.194,
														-29.382
													],
													[
														-2.473,
														-8.985
													],
													[
														11.064,
														-2.707
													],
													[
														3.255,
														9.544
													],
													[
														-0.236,
														4.635
													],
													[
														13.577,
														-28.735
													],
													[
														12.822,
														14.978
													],
													[
														-9.333,
														7.99
													],
													[
														-7.885,
														20.668
													],
													[
														-48.626,
														-2.758
													],
													[
														0.078,
														-6.751
													],
													[
														0.22,
														-34.259
													],
													[
														-1.111,
														-9.253
													],
													[
														9.294,
														-0.657
													],
													[
														0,
														0
													],
													[
														-0.879,
														44.662
													]
												],
												"v": [
													[
														-1.694,
														-8.671
													],
													[
														-12.32,
														-97.705
													],
													[
														-1.244,
														-117.075
													],
													[
														21.425,
														-95.065
													],
													[
														32.146,
														-7.089
													],
													[
														30.948,
														0.244
													],
													[
														90.834,
														-33.267
													],
													[
														78.599,
														4.289
													],
													[
														46.71,
														49.642
													],
													[
														-29.201,
														113.874
													],
													[
														-103.263,
														47.13
													],
													[
														-103.088,
														14.782
													],
													[
														-110.236,
														-79.633
													],
													[
														-96.064,
														-98.178
													],
													[
														-77.212,
														-82.566
													],
													[
														-69.379,
														-4.701
													]
												],
												"c": false
											}
										]
									}
								],
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 12,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									145.383,
									143.816
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 180,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/WavingHand.json
// module id = 72
// module chunks = 0